module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab5/awsop-lab5.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab5/awsop-lab5.component.css
// module chunks = main